import { Component } from '@angular/core';
import {ThemeService} from '../../core/services/theme.service';
import {HoomvipLogoComponent} from '../../shared/components/hoomvip-logo/hoomvip-logo.component';
import {RoundButtonComponent} from '../../shared/components/round-button/round-button.component';
import {HoomvipStorage} from '../../core/hoomvip-storage/hoomvip-storage.service';
import {QRCodeComponent} from 'angularx-qrcode';
import {RouterService} from '../../core/services/router.service';

@Component({
  selector: 'app-desktop',
  standalone: true,
  templateUrl: './desktop.component.html',
  styleUrls: ['./desktop.component.scss'],
  imports: [
    HoomvipLogoComponent,
    RoundButtonComponent,
    QRCodeComponent
  ]
})
export class DesktopComponent {

  constructor(
    private theme: ThemeService,
    private hoomvipStorage: HoomvipStorage,
    private router: RouterService,
    ) {}

  getQrPath(): string {
    const qrUrl = this.theme.getQrPath();

    return `https:/${this.router.withBrandingParam(qrUrl)}`;
  }

  getLogoPath(): string {
    return this.theme.getLogoPath();
  }

  protected goToLogin() {
    this.hoomvipStorage.setDetectMobile(false);
    window.location.href = this.router.withBrandingParam('/login');
    window.location.reload();
  }
}
